import React, { useState, useRef, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import TextareaAutosize from 'react-textarea-autosize';
import { useChatContext } from '../../../providers/ChatProvider';

const ChatInput = () => {
  const { 
    sendMessage, 
    isLoading, 
    textAreaInitialHeight, 
    setTextAreaInitialHeight 
  } = useChatContext();
  
  const [message, setMessage] = useState('');
  const textAreaRef = useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (message.trim() && !isLoading) {
      sendMessage(message.trim());
      setMessage('');
      
      // Reset textarea height
      if (textAreaRef.current) {
        textAreaRef.current.style.height = `${textAreaInitialHeight}px`;
      }
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  const handleInputChange = (e) => {
    setMessage(e.target.value);
  };

  useEffect(() => {
    if (textAreaRef.current && textAreaInitialHeight === 32) {
      const height = textAreaRef.current.offsetHeight;
      if (height > 32) {
        setTextAreaInitialHeight(height);
      }
    }
  }, [textAreaInitialHeight, setTextAreaInitialHeight]);

  return (
    <div className="chat-input-area">
      <form onSubmit={handleSubmit} className="chat-input-container">
        <TextareaAutosize
          ref={textAreaRef}
          className="chat-textarea"
          placeholder={isLoading ? "Galaxy AI está escribiendo..." : "Escribe tu pregunta aquí..."}
          value={message}
          onChange={handleInputChange}
          onKeyPress={handleKeyPress}
          disabled={isLoading}
          minRows={1}
          maxRows={4}
          style={{ height: textAreaInitialHeight }}
        />
        <Button
          type="submit"
          variant="primary"
          className="chat-send-button"
          disabled={!message.trim() || isLoading}
          title="Enviar mensaje"
        >
          <FontAwesomeIcon icon={faPaperPlane} />
        </Button>
      </form>
    </div>
  );
};

export default ChatInput; 